import NormFMSB from "./norm_fm_sb.svg";
import NormFM from "./norm_fm.svg";
import NormSB from "./norm_sb.svg";
import EmerFMSB from "./emer_fm_sb.svg";
import EmerFM from "./emer_fm.svg";
import EmerSB from "./emer_sb.svg";
import DefaultIcon from "./icon-generic-pin.svg";
import EmergencyIcon from "./emergency-pin.svg";
import LocationIcon from "./my_location_dot.svg";
import Download from "./download.svg";
import PGE from "./pge_logo.svg";
import SelfServiceCheckmark from "./selfservice/checkmark.svg";
import SelfServiceDelete from "./selfservice/delete.svg";
import SelfServiceDiscard from "./selfservice/discard.svg";
import SelfServiceEdit from "./selfservice/edit.svg";
import SelfServiceEditDisabled from "./selfservice/edit-disabled.svg";
import SelfServiceError from "./selfservice/error.svg";
import SelfServiceSave from "./selfservice/save.svg";
import SelfServiceUndo from "./selfservice/undo.svg";
import SelfServiceUndoDisabled from "./selfservice/undo-disabled.svg";
import AlpineCheckboxChecked from "./alpine-checkbox-checked.svg";
import AlpineCheckboxUnchecked from "./alpine-checkbox-unchecked.svg";

export {
  PGE,
  Download,
  LocationIcon,
  DefaultIcon,
  NormFMSB,
  NormFM,
  NormSB,
  EmergencyIcon,
  EmerFMSB,
  EmerFM,
  EmerSB,
  SelfServiceCheckmark,
  SelfServiceDelete,
  SelfServiceDiscard,
  SelfServiceEdit,
  SelfServiceEditDisabled,
  SelfServiceError,
  SelfServiceSave,
  SelfServiceUndo,
  SelfServiceUndoDisabled,
  AlpineCheckboxChecked,
  AlpineCheckboxUnchecked,
};
